import * as React from "react";
import "../../Styles/RiskViews.scss";
import { Grid, GridColumn, GridDetailRow } from "@progress/kendo-react-grid";
import MitigationNameCell from "../Tenant/Component/MitigationNameCell";
import MitigationStatus from "../Tenant/Component/MitigationStatus";

export class CopyExpandActionDetails extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {};
  }

  approvedCell = (event) => {
    return <td>{event.dataItem.approved ? "Yes" : "No"}</td>;
  };
  onEditCell = () => {};
  render() {
    const data = this.props.dataItem.mitigationResps;

    if (data) {
      return (
        <div className="riskReportMitigation">
          <Grid data={data} reorderable resizable>
            <GridColumn
              field="approved"
              title="Approved"
              width="80px"
              cell={this.approvedCell}
            />
            <GridColumn
              field="number"
              title="Action Number"
              width="100px"
              locked={true}
            />
            <GridColumn
              field="name"
              title="Name"
              width="120px"
              locked={true}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="control"
              title="Description"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="externalReference"
              title="External Reference"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="actionType"
              title="Action Type"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="isOpen"
              title="Status"
              width="80px"
              editor="boolean"
              cell={(props) => (
                <MitigationStatus {...props} onEditCell={this.onEditCell} />
              )}
            />
          </Grid>
        </div>
      );
    }
    return (
      <div style={{ height: "50px", width: "100%" }}>
        <div style={{ position: "absolute", width: "100%" }}>
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }
}
